import type { PreloadModuleInfo } from '@meego-fw/core';
import { createLogger, injectable } from '@meego-fw/core';
import { IModuleLoader } from '@meego-remote/core/app/contract';
import { loadRemoteModule } from '@meego/remote-loader';

@injectable()
export class MainRepoModuleLoader extends IModuleLoader {
  private logger = createLogger('MainRepoModuleLoader');

  private getModuleFunc(module: PreloadModuleInfo) {
    return module.type === 'module'
      ? () => loadRemoteModule(module.key, module.m)
      : module.type === 'umd'
        ? console.error('NotImpl load umd', module)
        : undefined;
  }

  async load(module: PreloadModuleInfo) {
    this.logger.log('load', module);

    const st = performance.now();
    const loadFunc = this.getModuleFunc(module);
    if (!loadFunc) {
      this.logger.error('module loader function not found', module);
      return;
    }
    this.logger.log('loading', module);
    const load = loadFunc()
      ?.then(() => {
        this.logger.log('loaded', module, performance.now() - st);
      })
      .catch((e: any) => {
        console.error('load fail!', module, e);
        throw e;
      });
    return load;
  }

  async get(module: PreloadModuleInfo) {
    return this.getModuleFunc(module)?.();
  }
}
